import {
  encodeDelimitedArray,
  decodeDelimitedArray,
  encodeDelimitedNumericArray,
  decodeDelimitedNumericArray
} from 'use-query-params'

export const CommaArrayParam = {
  encode: (array: (string | null)[] | null | undefined) =>
    encodeDelimitedArray(array, ','),

  decode: (arrayStr: string | (string | null)[] | null | undefined) =>
    decodeDelimitedArray(arrayStr, ',')
}

export const CommaNumericArrayParam = {
  encode: (array: (number | null)[] | null | undefined) =>
    encodeDelimitedNumericArray(array, ','),

  decode: (arrayStr: string | (string | null)[] | null | undefined) =>
    decodeDelimitedNumericArray(arrayStr, ',')
}
